module.exports = __webpack_public_path__ + "img/logo--white.94b5916c.svg";